module.exports = __webpack_public_path__ + "img/manageModelImg3.f202da80.png";